import { getContext, track } from '../core';

/** Track clicks on the P&D download pop-out CTA. */
export function initPandCtaTracking(): void {
  document.addEventListener('click', (e) => {
    const anchor = (e.target as HTMLElement).closest<HTMLAnchorElement>(
      '#pand-cta .pand-cta__link',
    );
    if (!anchor) return;

    track('p_and_d_popup_download', {
      page_name: getContext().page_name,
      link_url: anchor.href,
    });
  });
}
